module.exports = __webpack_public_path__ + "assets/img/161cb2c636796c7f81f170dc2659d909.svg";